import { createClient, newIdempotencyKey } from '@shared/client';

const ORG_KEY = 'si.activeOrg';

function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

export function getActiveOrg(): string | null {
  try {
    return localStorage.getItem(ORG_KEY);
  } catch {
    return null;
  }
}

export function setActiveOrg(id: string | null) {
  try {
    if (id) localStorage.setItem(ORG_KEY, id);
    else localStorage.removeItem(ORG_KEY);
  } catch {
    /* storage unavailable: org stays in memory via React state */
  }
}

export const api = createClient({
  baseUrl: '',
  getOrgId: getActiveOrg,
  getCsrf: () => readCookie('si_csrf'),
  onUnauthenticated: () => window.dispatchEvent(new Event('si:unauthenticated')),
});

/**
 * One idempotency key per user action, kept in sessionStorage so that a
 * page refresh followed by "submit again" replays the original result
 * instead of applying the action twice.
 */
export function actionKey(scope: string): { key: string; done: () => void } {
  const storageKey = `si.key.${scope}`;
  let key: string | null = null;
  try {
    key = sessionStorage.getItem(storageKey);
  } catch {
    /* ignore */
  }
  if (!key) {
    key = newIdempotencyKey(scope.replace(/[^A-Za-z0-9_\-:.]/g, '').slice(0, 30) || 'k');
    try {
      sessionStorage.setItem(storageKey, key);
    } catch {
      /* ignore */
    }
  }
  return {
    key,
    done: () => {
      try {
        sessionStorage.removeItem(storageKey);
      } catch {
        /* ignore */
      }
    },
  };
}
